export class ReleaseBoardDTO {

    id: number;

    releaseVersionNo: String;

    releaseType: String;

    description: String;

    mailSubject: String;

    fileName: String;

    isMailSent: String;

    releaseStamp: String;

    mailBodyImage: String;

    cc: String;

}